import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Calendar, MapPin } from 'lucide-react';

const Exhibitions = () => {
  const { t } = useLanguage();

  const pastExhibitions = [
    {
      year: '2021',
      title: 'Expo Climbing District',
      location: 'Île-de-France, France',
      description: {
        en: 'Group exhibition featuring urban-inspired artworks in a unique climbing venue.',
        fr: 'Exposition collective présentant des œuvres d\'inspiration urbaine dans un lieu d\'escalade unique.'
      }
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-5xl md:text-6xl font-bold mb-12 text-center">{t.exhibitions.title}</h1>

        {/* Open to Opportunities */}
        <section className="mb-16 bg-gradient-to-br from-orange-50 to-blue-50 rounded-lg p-8 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-2xl font-bold mb-3">{t.exhibitions.collaboration}</h3>
              <p className="text-gray-700">
                {t.language === 'en'
                  ? 'Available for gallery shows, pop-up exhibitions, and collaborative projects with other artists.'
                  : 'Disponible pour des expositions en galerie, des expositions éphémères et des projets collaboratifs avec d\'autres artistes.'}
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-2xl font-bold mb-3">{t.exhibitions.residencies}</h3>
              <p className="text-gray-700">
                {t.language === 'en'
                  ? 'Seeking artist residencies to dedicate focused time to new series and experimental work.'
                  : 'Recherche de résidences d\'artistes pour consacrer du temps concentré à de nouvelles séries et des travaux expérimentaux.'}
              </p>
            </div>
          </div>
        </section>

        {/* Past Exhibitions */}
        <section>
          <h2 className="text-3xl font-bold mb-8 border-b-2 border-black pb-2 inline-block">
            {t.exhibitions.past}
          </h2>
          <div className="space-y-6">
            {pastExhibitions.map((exhibition, idx) => (
              <div key={idx} className="bg-white rounded-lg p-8 shadow-sm">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-2xl font-bold text-gray-900">{exhibition.title}</h3>
                  <span className="px-4 py-1 bg-black text-white rounded-full text-sm font-medium">
                    {exhibition.year}
                  </span>
                </div>
                <div className="flex items-center space-x-2 text-gray-600 mb-4">
                  <MapPin className="w-4 h-4" />
                  <span>{exhibition.location}</span>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {t.language === 'en' ? exhibition.description.en : exhibition.description.fr}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Exhibitions;
